import React, { useState } from "react";
import { Form, Row, Col, Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-hot-toast";
import { FiHome, FiChevronRight, FiPlus } from "react-icons/fi";

import { getExpense } from "../../store/slices/expense";
import { PDFDownloadLink } from "@react-pdf/renderer";
import ExpenseReport from "../admin/expenseReport";


export default function Expense() {
  const dispatch = useDispatch();

  const [errors, setErrors] = useState({});
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [search, setSearch] = useState("");

  const institute = useSelector(
    (state) => state.auth?.institute
  );
  const [expenses, setExpenses] = useState([]);

  const validate = () => {
    const newErrors = {};



    if (fromDate && toDate && new Date(fromDate) > new Date(toDate)) {
      newErrors.toDate = "To Date must be after From Date";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };




  const handleSearch = () => {
    if (!validate()) return;

    dispatch(
      getExpense({

        fromDate,
        toDate,
        q: search,
      })
    )
      .unwrap()
      .then((res) => {
        setExpenses(res.data || []);
      })
      .catch((err) => {
        toast.error(err);
      });
  };
  return (
    <>
      <div className="page-header">
        <div className="breadcrumb-section">
          <div className="breadcrumb-left">
            <div className="home-icon">
              <Link to="/accounts/home">
                <FiHome style={{ color: "white", marginTop: "-4px" }} />
              </Link>
            </div>



            <FiChevronRight className="separator" />

            <span className="active">Expenses</span>
          </div>
          <div className="d-flex align-items-center gap-2">

            <Link
              to="/accounts/add-expense"
              className="add-btn"
            >
              <FiPlus />
              Add Expense
            </Link>

          </div>
        </div>
      </div>
      <div className="acs-card">
        <Form onSubmit={handleSearch}>
          <Row className="g-3">



            {/* From Date */}
            <Col md={3}>
              <Form.Group>
                <Form.Label>From Date</Form.Label>
                <Form.Control
                  type="date"
                  value={fromDate}
                  max={toDate || undefined}
                  onChange={(e) => setFromDate(e.target.value)}
                />
              </Form.Group>
            </Col>

            {/* To Date */}
            <Col md={3}>
              <Form.Group>
                <Form.Label>To Date</Form.Label>
                <Form.Control
                  type="date"
                  value={toDate}
                  min={fromDate || undefined}
                  max={new Date().toISOString().split("T")[0]}
                  onChange={(e) => setToDate(e.target.value)}
                />
                {errors.toDate && (
                  <div className="text-danger mt-1">
                    {errors.toDate}
                  </div>
                )}
              </Form.Group>
            </Col>

            {/* Search */}
            <Col md={3}>
              <Form.Group>
                <Form.Label>Search</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Search Name / Towards"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </Form.Group>
            </Col>

          </Row>

          <Row className="mt-5">
            <Col className="d-flex justify-content-center">
              <button
                type="button"
                className="btn-submit" style={{ width: "150px" }}
                onClick={handleSearch}
              >
                Search
              </button>

              <div className="d-flex align-items-center gap-2">

                {expenses.length > 0 && (

                  <PDFDownloadLink
                    document={
                      <ExpenseReport
                        expenses={expenses}
                        institute={institute}
                        fromDate={fromDate}
                        toDate={toDate}
                      />
                    }
                    fileName="expense-report.pdf"
                    style={{
                      textDecoration: "none",
                    }}
                  >
                    {({ loading }) => (
                      <button
                        type="button"
                        className="btn-submit ms-2" style={{ width: "150px" }}
                        disabled={loading}
                      >
                        {loading
                          ? "Generating..."
                          : "Export PDF"}
                      </button>
                    )}
                  </PDFDownloadLink>

                )}

              </div>
            </Col>


          </Row>
          {expenses.length > 0 && (

            <div className="table-responsive mt-4">

              <Table className="staff-table align-middle">

                <thead className="table-light">

                  <tr>

                    <th className="text-center">#</th>

                    <th className="text-center">Name</th>

                    <th className="text-center">Towards</th>

                    <th className="text-center">Amount</th>

                    <th className="text-center">Payment Mode</th>

                    <th className="text-center">Date</th>

                    <th className="text-center">Bill</th>

                    <th className="text-center">Receipt</th>

                  </tr>

                </thead>

                <tbody>

                  {expenses.map((item, index) => (

                    <tr key={item._id || index}>

                      <td className="text-center">
                        {index + 1}
                      </td>

                      <td className="text-center">{item.name}</td>

                      <td className="text-center">{item.towards}</td>

                      <td className="text-center">
                        ₹{Number(item.amount).toLocaleString()}
                      </td>

                      <td className="text-center">{item.paymentMode}</td>

                      <td className="text-center">
                        {new Date(item.date).toLocaleDateString("en-GB")}
                      </td>

                      <td className="text-center">

                        {item.bill ? (

                          <a
                            href={item.bill}
                            target="_blank"
                            rel="noreferrer"
                          >
                            View
                          </a>

                        ) : (

                          "-"

                        )}

                      </td>

                      <td className="text-center">

                        {item.receipt ? (

                          <a
                            href={item.receipt}
                            target="_blank"
                            rel="noreferrer"
                          >
                            View
                          </a>

                        ) : (

                          "-"

                        )}

                      </td>

                    </tr>

                  ))}

                </tbody>

              </Table>

            </div>

          )}
        </Form>
      </div>
    </>
  );
}